import { AdditionalTicketInformationListCombinedProps } from './types';

const usePresenter = (props: AdditionalTicketInformationListCombinedProps): AdditionalTicketInformationListCombinedProps => {
  return props;
};

export default usePresenter;
